export function handleEnvVars(env: Record<string, string>) {
  const VALID_MOCK_MODES = ["full", "mixed"] as const;
  type MockMode = (typeof VALID_MOCK_MODES)[number];
  const mockMode = VALID_MOCK_MODES.includes(env.VITE_MOCK_MODE as MockMode)
    ? (env.VITE_MOCK_MODE as MockMode)
    : undefined;
  const devToken = env.VITE_DEV_TOKEN || undefined;
  const devCredentials = env.VITE_DEV_CREDENTIALS || undefined;
  const isProxied = env.VITE_IS_PROXIED || "false";
  const requiresAuth0 = !devToken && !devCredentials && mockMode !== "full";

  const apiBaseUrl = env.VITE_API_BASE_URL;

  const auth0Domain = env.VITE_AUTH0_DOMAIN;
  const auth0ClientId = env.VITE_AUTH0_CLIENT_ID || "";
  const auth0Audience = env.VITE_AUTH0_AUDIENCE || "";

  const buildVariant = env.VITE_BUILD_VARIANT || "platform";
  const buildFeatureSet = env.VITE_BUILD_FEATURE_SET || "default";

  if (!env.PROD) {
    console.debug("apiBaseUrl: ", apiBaseUrl);
    console.debug("auth0Domain: ", auth0Domain);
    console.debug("buildVariant: ", buildVariant);
    console.debug("buildFeatureSet: ", buildFeatureSet);
  }

  return {
    apiBaseUrl,
    devToken,
    devCredentials,
    isProxied,
    mockMode,
    requiresAuth0,
    auth0Domain,
    auth0ClientId,
    auth0Audience,
    buildVariant,
    buildFeatureSet,
  };
}
